import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { ChromCount } from '../lib/stats';
import { CHART_COLORS, type Theme } from '../lib/theme';

interface Props {
  data: ChromCount[];
  theme: Theme;
}

export function ChromosomeChart({ data, theme }: Props) {
  const c = CHART_COLORS[theme];
  return (
    <div style={{ width: '100%', height: 260 }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={c.grid} vertical={false} />
          <XAxis
            dataKey="chrom"
            tick={{ fill: c.axis, fontSize: 11 }}
            axisLine={{ stroke: c.grid }}
            tickLine={false}
            interval={0}
          />
          <YAxis
            tick={{ fill: c.axis, fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            width={48}
            tickFormatter={(v: number) => (v >= 1000 ? `${Math.round(v / 1000)}k` : String(v))}
          />
          <Tooltip
            cursor={{ fill: c.cursor }}
            contentStyle={{
              background: c.tooltipBg,
              border: `1px solid ${c.tooltipBorder}`,
              borderRadius: 10,
              color: c.tooltipText,
            }}
            labelFormatter={(l) => `Chromosome ${l}`}
            formatter={(v: number) => [v.toLocaleString(), 'variants']}
          />
          <Bar dataKey="count" fill={c.bar} radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
